import { PropsWithChildren } from 'react';
import styled, { css } from 'styled-components';

import { getFontColor } from './utils/colors';

const StyledBadgeList = styled.div`
  display: inline-flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 4px;
  align-items: center;
`;

type BadgeProps = PropsWithChildren<{
  size?: 'small' | 'medium' | 'large';
  $color?: string;
}>;

const StyledBadge = styled.div<BadgeProps>`
  display: inline;
  border-radius: 2px;
  background-color: ${({ theme, $color }) => $color || theme.colors.N60};
  color: ${({ theme, $color }) => getFontColor($color || theme.colors.N60)};
  padding: 0.3em 0.9em;
  ${({ size }) => {
    switch (size) {
      case 'small':
        return css`
          font-size: 9px;
        `;
      case 'large':
        return css`
          font-size: 15px;
        `;
      case 'medium':
      default:
        return css`
          font-size: 12px;
        `;
    }
  }};
`;

type BadgeListProps = PropsWithChildren<{}>;

export function BadgeList({ children }: BadgeListProps) {
  return <StyledBadgeList>{children}</StyledBadgeList>;
}

function Badge({ size, $color, children, ...rest }: BadgeProps) {
  return (
    <StyledBadge size={size} $color={$color} {...rest}>
      {children}
    </StyledBadge>
  );
}

export default Badge;
